import { defineTranslation } from './define';

export const zh = defineTranslation({
  "state.unavailableBody": "此结账页面暂时不可用。请稍后重试。",
  "action.accessExpired": "此访问已过期或不可用。请申请新链接以继续。",
  "action.requestLink": "发送新链接",
  "action.linkSent": "如果此访问有效，我们将向已登记的电子邮箱发送新链接。",
  "action.accessProcessing": "付款可能仍在处理中。请申请新链接以查询状态。请勿再次付款。",

  "error.priceChangedTitle": "信息已过期",
  "block.PRECO_ALTERADO": "此笔购买的信息已过期。请刷新页面并核对金额后再继续。",
  "error.refresh": "刷新页面",
  "error.priceRefreshed": "汇率已更新。请核对价格并再次确认。",
  "summary.loading": "正在加载订单摘要",
  "summary.unavailableTitle": "订单摘要暂不可用",
  "summary.unavailableBody": "无法加载详情。请查看您的购买确认邮件。",
  "summary.mainPurchase": "主要购买项目",
  "summary.additionalOffer": "附加优惠",
  "upsell.protectedOffer": "受保护的优惠",
  "upsell.storageTitle": "请确认以查看您的优惠",
  "upsell.storageDeniedTitle": "此浏览器无法显示优惠",
  "upsell.storageBody": "您的浏览器会保护跨网站数据。请授权 VendePay 安全加载此优惠。",
  "upsell.storageDeniedBody": "浏览器未允许在此网站上访问。请在 VendePay 上安全打开优惠，或跳过此优惠继续。",
  "upsell.loading": "加载中…",
  "upsell.loadOffer": "加载优惠",
  "upsell.openHosted": "在 VendePay 上打开优惠",
  "error.retry": "重试",
  "error.systemTitle": "出现了问题",
  "error.validationTitle": "请检查您的信息",
  "error.paymentTitle": "付款未完成",
  "action.processingTitle": "付款处理中",
  "action.canceledTitle": "已申请取消",
  "action.alreadyCanceledTitle": "订阅已取消",
  "action.cardUpdatedTitle": "银行卡已更新",
  "action.paidTitle": "付款已处理",
  "action.cancelTitle": "取消订阅",
  "action.cardTitle": "更换银行卡",
  "action.payTitle": "支付账单",
  "action.loading": "正在加载链接…",
  "action.canceledBody": "订阅将在当前周期结束时终止。",
  "action.alreadyCanceledBody": "您无需再次申请取消订阅。",
  "action.cardUpdatedBody": "订阅的银行卡已更新。您可以关闭此页面。",
  "action.paidBody": "账单已更新。您可以关闭此页面。",
  "action.processingBody": "扣款已确认，正在等待支付服务商结算。请勿重复付款。",
  "action.plan": "套餐",
  "action.status": "状态",
  "action.invoice": "账单",
  "action.period": "当前周期",
  "action.until": "截至 {{date}}",
  "action.authentication": "您的银行要求对银行卡进行安全验证。",
  "action.cancelButton": "在周期结束时取消",
  "action.saveButton": "保存银行卡",
  "action.authenticateButton": "验证银行卡",
  "action.payButton": "立即付款",
  "action.trialing": "试用中",
  "action.active": "有效",
  "action.pastDue": "已逾期",
  "action.canceled": "已取消",
  "action.pending": "待处理",
  "action.processing": "处理中",
  "action.awaitingAction": "需要操作",
  "action.paid": "已支付",
  "action.inGrace": "宽限期内",
  "action.failed": "失败",
  'language.select': '语言', 'common.demo': '演示', 'common.emailFallback': '您的电子邮箱',
  'common.processing': '处理中…', 'common.free': '免费', 'common.today': '今天', 'common.total': '总计',
  'common.unavailable': '不可用', 'common.onRequest': '请咨询',
  'period.minute.one': '分钟', 'period.minute.other': '分钟',
  'period.day.one': '天', 'period.day.other': '天', 'period.week.one': '周', 'period.week.other': '周',
  'period.month.one': '个月', 'period.month.other': '个月', 'period.year.one': '年', 'period.year.other': '年',
  'period.single': '/{{unit}}', 'period.every': ' 每 {{count}} {{unit}}', 'period.for': '每{{unit}}',
  'field.name': '全名', 'field.namePlaceholder': '与证件上的姓名一致', 'field.email': '电子邮箱',
  'field.emailPlaceholder': 'you@email.com', 'field.phone': '手机 / WhatsApp',
  'field.internationalPhone': '国际电话号码（可选）', 'field.internationalPhonePlaceholder': '+ 国家代码和号码',
  'field.document': '证件', 'field.documentPlaceholder': '证件号码',
  'pii.email': '我的电子邮箱', 'pii.phone': '我的电话号码', 'pii.emailPhone': '我的电子邮箱和电话号码',
  'pii.optional': '可选: 不影响购买', 'pii.consent': '我同意对{{target}}进行哈希保护后使用，以衡量本次购买的广告转化。',
  'state.loading': '正在加载结账页面…', 'state.notFoundTitle': '结账页面不可用',
  'state.notFoundBody': '此结账页面不存在或已停用。', 'state.errorTitle': '出现错误',
  'state.errorBody': '暂时无法加载此结账页面，请稍后重试。',
  'error.payment': '无法完成付款。', 'error.cardDetails': '请检查银行卡信息。',
  'error.checkoutUnavailable': '此结账页面目前无法购买。', 'error.subscriptionCardOnly': '订阅只能使用银行卡支付。',
  'error.emailWalletRequired': '请输入电子邮箱以继续使用钱包。', 'error.emailWalletInvalid': '请输入有效的电子邮箱以继续使用钱包。',
  'error.emailRequired': '请输入电子邮箱以完成购买。', 'error.emailInvalid': '请输入有效的电子邮箱以完成购买。',
  'error.confirmationExpired': '确认已过期，请重试。', 'error.authentication': '无法完成银行卡验证。',
  'error.offerUnavailable': '此优惠目前不可用。', 'error.offerProcessing': '无法处理此优惠。',
  'decline.currency_not_supported': '此银行卡不支持本次购买所用的币种。请尝试使用其他银行卡或付款方式。',
  'decline.card_not_supported': '此银行卡不支持此类购买。请使用其他银行卡或联系发卡行。',
  'decline.incorrect_address': '账单地址不正确。请检查信息后重试。',
  'decline.incorrect_zip': '账单地址的邮政编码不正确。请检查信息后重试。',
  'decline.invalid_expiry': '银行卡有效期不正确。请检查月份和年份后重试。',
  'decline.invalid_account': '此银行卡无法用于付款。请使用其他银行卡或联系发卡行。',
  'decline.invalid_amount': '此金额不允许使用这张银行卡支付。请使用其他银行卡或联系发卡行。',
  'decline.duplicate_transaction': '最近已提交过一笔信息相同的购买。请在重试前确认付款是否已经成功。',
  'decline.contact_issuer': '无法授权此笔购买。请使用其他银行卡或联系发卡行。',
  'decline.testmode_decline': '此测试银行卡不能用于本次购买。请使用其他银行卡。',
  'decline.authentication_failure': '无法完成银行卡验证。请重试并完成验证。',
  'decline.card_decline_rate_limit_exceeded': '此银行卡的付款被拒次数过多。请等待24小时或使用其他银行卡。',
  'decline.card_velocity_exceeded': '此银行卡已达到余额、信用额度或单笔消费金额上限。请使用其他银行卡或联系发卡行。',
  'decline.insufficient_funds': '余额不足。请使用其他银行卡或付款方式。',
  'decline.expired_card': '此银行卡已过期。请检查有效期或使用其他银行卡。',
  'decline.incorrect_cvc': '银行卡安全码不正确。请检查CVC并重试。',
  'decline.invalid_cvc': '银行卡安全码无效。请检查CVC并重试。',
  'decline.incorrect_number': '银行卡号不正确。请检查信息后重试。',
  'decline.invalid_number': '银行卡号无效。请检查信息后重试。',
  'decline.authentication_required': '您的银行要求对此次购买进行身份验证。请重试并完成验证。',
  'decline.processing_error': '目前无法处理此银行卡。请稍后重试。',
  'decline.issuer_not_available': '发卡行暂不可用。请稍后重试或使用其他银行卡。',
  'decline.try_again_later': '银行要求稍后重试。请稍等片刻或使用其他银行卡。',
  'decline.subscriptionContext': '无法确认您的订阅。{{message}}',
  'decline.default': '无法完成付款。请尝试使用其他银行卡或付款方式。',
  'payment.card': '银行卡', 'payment.creditCard': '信用卡', 'payment.boleto': '付款单', 'payment.method': '付款方式',
  'payment.express': '快速付款', 'payment.otherMethods': '其他付款方式',
  'payment.recurring': '定期', 'payment.upfront': '一次性', 'payment.instant': '即时', 'payment.approved': '已付款',
  'payment.pending': '等待确认', 'payment.awaitingPix': '等待 Pix 确认', 'payment.requiresAction': '等待验证', 'payment.notConfirmed': '未确认',
  'payment.firstChargePaid': '首笔费用已支付', 'payment.freeTrialStarted': '免费试用已开始',
  'payment.cardEnding': '{{brand}} 尾号 {{last4}}', 'payment.processingWallet': '正在通过 {{wallet}} 处理付款…',
  'payment.completeWallet': '请在 {{wallet}} 中完成付款',
  'payment.walletHelp': '请使用已打开的安全窗口。如果取消，银行卡输入框会自动恢复。',
  'payment.or': '或', 'payment.secureConnection': '付款数据受 TLS 连接保护', 'payment.cardNumber': '卡号',
  'payment.cardholderName': '持卡人姓名', 'payment.cardholderPlaceholder': '与银行卡上的姓名一致',
  'payment.expiry': '有效期', 'payment.cvv': 'CVV', 'payment.walletReceipt': '确认信息和收据将发送至 {{email}}。',
  'payment.processedBy': '付款由 VendePay 和付款服务商处理。数据将按照隐私政策进行处理。',
  'checkout.securePurchase': '安全购买', 'checkout.choosePlan': '选择套餐', 'checkout.bestValue': '最划算',
  'checkout.yourDetails': '您的信息', 'checkout.guest': '无需创建账户即可购买: 您可以稍后设置密码。',
  'checkout.payment': '付款', 'checkout.completeOrder': '完成您的订单', 'checkout.orderSummary': '订单摘要', 'checkout.reviewSummary': '购买摘要',
  'checkout.chargedNow': '本次收费', 'checkout.totalChargedNow': '本次收费总额',
  'checkout.awaitingConfirmation': '等待确认', 'checkout.recurringCharges': '定期收费',
  'checkout.nextCharges': '后续收费', 'checkout.subscriptionActive': '订阅已生效。取消链接已发送至电子邮箱。',
  'checkout.renewsFor': '将以 {{value}} 自动续订', 'checkout.subscribeFor': '以 {{value}} 订阅',
  'checkout.payAndFinish': '支付 {{value}} 并完成购买', 'checkout.startTrial': '开始 {{days}} 天免费试用',
  'checkout.startFree': '免费开始', 'checkout.subscribeNow': '立即订阅', 'checkout.payNow': '立即付款',
  'checkout.finishWallet': '在 {{wallet}} 中完成', 'checkout.productDelivery': '产品将由卖家交付。',
  'checkout.confirmationSent': '我们已将确认信息发送至 {{email}}。{{delivery}}',
  'checkout.guarantee': '{{days}} 天保障', 'checkout.fullRefundGuarantee': '{{days}} 天保障: 全额退款',
  'checkout.secureEncrypted': '安全付款 · 数据加密', 'checkout.dataProtected': '数据已保护',
  'checkout.cardNotStored': '我们不会保存您的银行卡',
  'coupon.percentDiscount': '百分比折扣',
  'coupon.fixedDiscount': '固定金额折扣',
  "coupon.appliesToProduct": "折扣仅适用于{{product}}。",
  "summary.purchaseItems": "本次购买的商品",
  "summary.purchaseTotal": "本次购买总额",
  'coupon.beforeDiscount': '使用优惠券前金额',
  'coupon.discountAmount': '已应用折扣',
  'coupon.afterDiscount': '使用优惠券后金额',
  'coupon.label': '优惠码 {{code}}', 'coupon.applied': '优惠码 已使用', 'coupon.remove': '移除',
  'coupon.code': '优惠码', 'coupon.validating': '验证中…', 'coupon.apply': '使用', 'coupon.haveOne': '有优惠码？',
  'coupon.invalid': '优惠码无效或已过期。', 'summary.trialPeriod': '试用期', 'summary.days': '{{days}} 天',
  'summary.totalToday': '今日总额', 'summary.recurringCharge': '定期收费',
  'pending.subscriptionTitle': '正在确认订阅',
  'pending.subscriptionBody': '验证已完成。我们正在启用免费试用，并会将确认信息发送至 {{email}}。',
  'pending.authenticationTitle': '需要验证', 'pending.authenticationBody': '您的银行要求额外验证。请完成验证以完成付款。',
  'success.added': '已添加！', 'success.addedBody': '已从您的银行卡收取 +{{value}}。',
  'success.subscriptionTitle': '订阅已开始！', 'success.freeDays': '您有 {{days}} 天免费试用。今天未收取费用。',
  'success.firstCharge': ' 首笔 {{value}} 将于 {{date}} 收取。',
  'success.subscriptionEmail': '确认信息和取消链接已发送至 {{email}}。', 'success.paymentTitle': '付款成功！',
  'subscription.single': '订阅', 'subscription.oneTime': '一次性购买',
  'subscription.bumpTerms': '银行卡订阅：自动续订。可通过电子邮件中的链接取消。',
  'subscription.afterPaidTrialTerms': '前 {{days}} 天结束后，将自动续订，费用为 ',
  'subscription.freeTerms': '{{days}} 天免费，今天不收费。之后 ',
  'subscription.renewalTerms': '自动续订：', 'subscription.cancelTerms': '。您可以在周期结束时通过电子邮件中的链接取消。',
  'upsell.downsellBadge': '等等！特别优惠', 'upsell.badge': '限时专属优惠',
  'upsell.addCard': '是的，将 +{{value}} 添加到我的银行卡', 'upsell.continueWithout': '不使用此优惠并继续',
  'upsell.reassurance': '付款成功: 完成前还有一个专属优惠', 'upsell.trialDays': '{{days}} 天试用',
  'upsell.oneClick': '安全一键购买', 'upsell.noCardAgain': '无需再次输入银行卡信息', 'installment.label': '{{count}} 期，每期 {{value}}',
  'legacy.urgency': '限时优惠', 'legacy.reassurance': '受保护的购买 · 付款后立即访问',
  'upsell.accept': '是的，我想要', 'upsell.reject': '不用了，谢谢',
});
